import $ from "jquery";

$(document).on('turbolinks:load', function () {
    let loggedIn = $('body').data('loggedIn');
    if (loggedIn !== undefined && loggedIn === true) {
        const channels = require.context('.', true, /_channel\.js$/);
        channels.keys().forEach(channels);
    }
});
